import { render } from "./ZoneWizardCoreZoneTypeStep.vue?vue&type=template&id=1a7b0c38&scoped=true"
import script from "./ZoneWizardCoreZoneTypeStep.vue?vue&type=script&lang=js"
export * from "./ZoneWizardCoreZoneTypeStep.vue?vue&type=script&lang=js"

import "./ZoneWizardCoreZoneTypeStep.vue?vue&type=style&index=0&id=1a7b0c38&scoped=true&lang=less"

import exportComponent from "/home/vinicius.valle/projetos/cloudstack/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7b0c38"]])

export default __exports__